<template>
  <div id="image-preview" class="image-preview-container-wrp m-auto">
    <div class="image-preview-header border-none">Attachment Image</div>
    <div class="image-preview-body border-none">
      <div class="image-preview-overall-list pt-1">
        <span>{{ currentPage }}/{{ imageList.length }}</span>
      </div>
      <div class="image-preview-show-image">
        <div class="image-preview-zoom-image">
          <div class="icon-zoom-wrp" @click="showFullscreen">
            <icon-zoom />
          </div>
          <div></div>
          <div class="icon-new-tab-wrp" @mousedown="openNewTab">
            <icon-new-tab />
          </div>
        </div>
        <div
          id="image"
          :class="checkImageSize ? 'h-320px' : ''"
          @click="showFullscreen"
          class="image-preview-content"
          :style="{
            backgroundImage: 'url(' + renderImage + ')',
            transform: 'rotate(' + rotateImage + 'deg)',
          }"
        >
          <!-- <div class="image-preview-zoom-image">
            <div class="icon-zoom-wrp" @click="showFullscreen">
              <icon-zoom />
            </div>
            <div></div>
            <div class="icon-new-tab-wrp" @mousedown="openNewTab">
              <icon-new-tab />
            </div>
          </div> -->
        </div>
      </div>
    </div>
    <div class="image-preview-footer">
      <div class="image-preview-rotate">
        <icon-rotate-left @click.native="onRotateImage('left')" />
        <icon-rotate-right @click.native="onRotateImage('right')" />
      </div>
      <div class="image-preview-pagination d-flex justify-content-center">
        <b-pagination
          v-model="currentPage"
          :total-rows="imageList.length"
          :per-page="1"
          class="mb-0 mt-1 mt-sm-0 pagination-with-reorder"
          prev-class="prev-item"
          next-class="next-item"
          first-class="prev-item"
          last-class="next-item"
        >
          <template #prev-text>
            <feather-icon icon="ChevronLeftIcon" size="18" />
          </template>
          <template #next-text>
            <feather-icon icon="ChevronRightIcon" size="18" />
          </template>
          <template #first-text>
            <feather-icon icon="ChevronsLeftIcon" size="18" />
          </template>
          <template #last-text>
            <feather-icon icon="ChevronsRightIcon" size="18" />
          </template>
        </b-pagination>
      </div>
    </div>
    <image-preview-fullscreen
      :imageUrl="renderImage"
      :rotate="rotateImage"
      :bindValue="showFullscreenImage.show"
      @closeModal="hideFullscreen"
    />
  </div>
</template>

<script>
import {
  computed,
  getCurrentInstance,
  onBeforeMount,
  reactive,
  ref,
  watch,
} from "@vue/composition-api";
import IconZoomImg from "@/@core/components/svg/common/IconZoomImg.vue";
import IconRotateLeft from "@/@core/components/svg/document-service/IconRotateLeft.vue";
import IconRotateRight from "@/@core/components/svg/document-service/IconRotateRight.vue";
import ImagePreviewFullscreen from "@/views/components/image-preview-list/ImagePreviewFullscreen.vue";
import IconNewTab from "@/@core/components/svg/document-service/IconNewTab.vue";
import IconZoom from "@/@core/components/svg/document-service/IconZoom.vue";
import useModal from "@/@core/components/base-modal/hooks/useModal";
export default {
  components: {
    IconZoomImg,
    IconRotateRight,
    IconRotateLeft,
    ImagePreviewFullscreen,
    IconNewTab,
    IconZoom,
  },
  props: { imageList: { type: Array, default: [] } },
  setup(props) {
    const vm = getCurrentInstance().proxy;

    const { openModal, closeModal } = useModal();

    const showFullscreenImage = reactive({
      show: false,
    });

    const currentPage = ref(1);

    const rotateList = ref([]);

    const imageData = reactive({
      height: "",
      width: "",
    });

    const renderImage = computed(() => {
      vm.$nextTick(() => {
        var img = new Image();
        img.src = encodeURI(props.imageList[currentPage.value - 1]?.imageUrl);
        img.onload = function () {
          imageData.height = img.height;
          imageData.width = img.width;
        };
      });
      return encodeURI(props.imageList[currentPage.value - 1]?.imageUrl);
    });

    const rotateImage = computed(() => {
      if (rotateList.value.length == 0) {
        rotateList.value = [...props.imageList];
      }
      return rotateList.value[currentPage.value - 1]?.rotate;
    });

    const onRotateImage = (side) => {
      if (side == "left") {
        rotateList.value[currentPage.value - 1].rotate -= 90;
      } else {
        rotateList.value[currentPage.value - 1].rotate += 90;
      }
    };

    const showFullscreen = () => {
      showFullscreenImage.show = true;
      openModal();
    };

    const hideFullscreen = () => {
      showFullscreenImage.show = false;
      closeModal();
    };

    const openNewTab = () => {
      window.open(encodeURI(props.imageList[currentPage.value - 1]?.imageUrl));
    };

    const checkImageSize = computed(() => {
      return (
        imageData.height == imageData.width ||
        imageData.height < imageData.width ||
        imageData.height < 750
      );
    });

    return {
      showFullscreenImage,
      currentPage,
      renderImage,
      rotateImage,
      onRotateImage,
      showFullscreen,
      hideFullscreen,
      openNewTab,
      imageData,
      checkImageSize,
    };
  },
};
</script>

<style scoped>
@import "~@/assets/css/override-styles/pagination-with-reorder.css";
@import "~@/assets/css/pages/document-detail/preview-image.css";
</style>
